import {Injectable} from '@angular/core';
import {ApiUrlConstants} from '@coreconstant';
import {HttpService, httpConfig} from '../http-service/http.service';

@Injectable({
    providedIn: 'root'
})
export class RecaptchaService {

    baseUrlApi = ApiUrlConstants.RECAPTCHA_BASE_URL;
    httpConfig: httpConfig;

    constructor(
        private _httpService: HttpService
    ) {
    }

    /**
     * Verifies the captcha by sending the provided input to the server.
     * @param {Object} input - The captcha input data to be verified.
     */
    verifyCaptcha(input) {
        this.httpConfig = {
            url: this.baseUrlApi,
            method: 'post',
            data: input
        }
        return this._httpService.init(this.httpConfig);
    }
}
